import { useIntl } from "react-intl";

import StarFilled28 from "@/icons/__generated__/StarFilled/StarFilled28";
import StarFilled48 from "@/icons/__generated__/StarFilled/StarFilled48";

type StatsBarSectionListItem = {
  id: string;
  statsBarItemValue: string | React.ReactNode;
  statsBarItemLabel: string;
};

const useStatsBarSectionList = (): StatsBarSectionListItem[] => {
  const intl = useIntl();

  return [
    {
      id: "paid_to_hosts",
      statsBarItemValue: "$500M+",
      statsBarItemLabel: intl.formatMessage({
        defaultMessage: "paid to hosts",
      }),
    },
    {
      id: "spaces_listed",
      statsBarItemValue: "50,000+",
      statsBarItemLabel: intl.formatMessage({
        defaultMessage: "spaces listed",
      }),
    },
    {
      id: "cities_worldwide",
      statsBarItemValue: "1,000+",
      statsBarItemLabel: intl.formatMessage({
        defaultMessage: "cities worldwide",
      }),
    },
    {
      id: "average_host_rating",
      statsBarItemValue: (
        <span className="tw-inline-flex tw-items-center tw-justify-center">
          4.9
          <StarFilled28 className="tw-text-white md:tw-hidden" aria-hidden />
          <StarFilled48
            className="tw-text-white tw-hidden md:tw-block"
            aria-hidden
          />
        </span>
      ),
      statsBarItemLabel: intl.formatMessage({
        defaultMessage: "average host rating",
      }),
    },
  ];
};

export { useStatsBarSectionList };
